import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICountry } from 'models/country';
import { ICompany } from 'models/company';
import { IDepartments } from 'models/departments';
import { IJob } from 'models/job';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  job: IJob;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditJob: React.FC<Props> = ({ open, loading, job, onClose, onSubmit, onChanges }) => {
  const {t} = useTranslation()
  let basicFields: IFormField[] = [
    // {
    //   name: 'logo',
    //   label: 'Logo',
    //   type: InputTypes.TEXT,
    //   defaultValue: company.logo,
    //   disabled: true,
    //   internalLabel: true,
    //   required: true
    // },
    {
      name: 'title',
      label: t('T_title'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_title'),
      defaultValue: job.title,
      internalLabel: true,
      required: true
    },
    {
      name: 'description',
      label: t('T_description'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_description'),
      defaultValue: job.description,
      internalLabel: true,
      required: true
    },
    {
      name: 'titleAr',
      label:  `${t('T_title')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder:  `${t('T_enter_title')} ${t('T_in_arabic')}`,
      internalLabel: true,
      defaultValue: job.titleAr,
      required: true
    },
    {
      name: 'descriptionAr',
      label:  `${t('T_description')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      defaultValue: job.descriptionAr,
      placeholder: `${t('T_enter_description')} ${t('T_in_arabic')}`,
      internalLabel: true,
      required: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_job')}  
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
             {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditJob;
